export const prod = true;
export const url = '//api52wan.001zhegame.com';
// export const url = '//api.gamebox.05zhegame.com';